export const ValidarNumLtr = (cadena) => {
    return REGEX_NL.test(cadena);
}
export const ValidarNumLtrNS = (cadena) => {
    return REGEX_NLNS.test(cadena);
} 
export const ValidarNum = (cadena) => {
    return REGEX_N.test(cadena);
}
export const ValidarLtr = (cadena) => {
    return REGEX_L.test(cadena);
}


const REGEX_NL = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]+$/;
const REGEX_NLNS = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]+$/;
const REGEX_N = /^[0-9]+$/;
const REGEX_L = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]+$/;
